module.exports = __webpack_public_path__ + "static/media/Combined Shape.08aa8328.svg";